module.exports = __webpack_public_path__ + "static/img/jiangping.5609877.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/jiangping.png
// module id = dALu
// module chunks = 1